export type ThemeMode = 'light' | 'dark';
export type LanguageCode = 'en' | 'vi';

export interface UserPreferences {
  userId: string;
  theme: ThemeMode;
  language?: LanguageCode;
}

export const DEFAULT_PREFERENCES: Omit<UserPreferences, 'userId'> = {
  theme: 'light',
  language: 'vi',
};
